import OnlyAdmin from 'components/guards/OnlyAdmin';
import React from 'react';

export default props => {
  if (props.type === "public") {
    return (
      <thead>
        <tr>
          <th style={{ textAlign: 'center' }}>Name</th>
          <th style={{ textAlign: 'center' }}>Price</th>
          <th style={{ textAlign: 'center' }}>Available</th>
          <th style={{ textAlign: 'center' }}>Bought</th>
          {
            props.fullView ?
              <>
                <th style={{ textAlign: 'center' }}>Offers Created</th>
                <OnlyAdmin>
                  <th style={{ textAlign: 'center' }}>Checked-In</th>
                </OnlyAdmin>
                <th style={{ textAlign: 'center' }}>Total</th>
              </> : null
          }
          <th style={{ textAlign: 'center' }}>Promoters</th>
          <th style={{ textAlign: 'center' }}>General Link</th>
          {
            props.public !== undefined && props.fullView ? <th>Auto on-sale After</th> : null
          }
          <th />
        </tr>
      </thead>
    );
  } else {
    return (
      <thead>
        <tr>
          <th style={{ textAlign: 'center' }}>Name</th>
          <th style={{ textAlign: 'center' }}>Available</th>
          <th style={{ textAlign: 'center' }}>Price</th>
          <th style={{ textAlign: 'center' }}>Offers Pending Purchase</th>
          <th style={{ textAlign: 'center' }}>Bought</th>
          <OnlyAdmin>
            <th style={{ textAlign: 'center' }}>Voided</th>
            <th style={{ textAlign: 'center' }}>Checked-In</th>
          </OnlyAdmin>
          <th style={{ textAlign: 'center' }}>Total</th>
          <th />
        </tr>
      </thead>
    );
  }

};



// WEBPACK FOOTER //
// ./src/pages/manage/events/edit/modules/ticketInventory/modules/TicketInventoryTableHeader.tsx